import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { reloadVlibras } from 'utils/acessibilidade';
import * as S from './styles';

export const TitlePage = ({ textTitle, backPage }) => {
  const history = useHistory();
  return (
    <S.Container id="ComponenteTituloPage">
      <S.ContainerIcon
        onClick={() => {
          history.push(backPage);
          reloadVlibras();
        }}
      >
        <ArrowLeftOutlined data-testid="icon voltar" style={{ fontSize: '14pt' }} />
      </S.ContainerIcon>
      <S.Texto>{textTitle}</S.Texto>
    </S.Container>
  );
};

TitlePage.propTypes = {
  textTitle: PropTypes.string,
  backPage: PropTypes.string,
};

TitlePage.defaultProps = {
  // textTitle: null,
  // backPage: '',
};

export default TitlePage;
